import { render, staticRenderFns } from "./ModuleCompletionFeedback.vue?vue&type=template&id=115f45e2&scoped=true"
import script from "./ModuleCompletionFeedback.vue?vue&type=script&lang=js"
export * from "./ModuleCompletionFeedback.vue?vue&type=script&lang=js"
import style0 from "./ModuleCompletionFeedback.vue?vue&type=style&index=0&id=115f45e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f45e2",
  null
  
)

export default component.exports